import React from 'react';
import PropTypes from 'prop-types';
import './icon.scss';
import type { IconProps } from './Icon.types'
import iconPaths from './selection';

const getPath = (iconName: string) => {
  const icons: any = iconPaths.icons;
  const icon = icons.find(
    (icon: any) => icon.properties.name === iconName
  );

  if (icon) {
    return icon.icon.paths.join(" ");
  } else {
    return "";
  }
};

const Icon = ({ iconName, size, className, onClick, style }: IconProps) => {
  return (
    <span
      className={`sb-icon flex justify-center items-center ${className ? className : ''}`}
      onClick={onClick}
      data-testid="sb-icon"
      style={{ ...style }}
    >
      <svg
        className="icon"
        data-testid="sb-icon__svg"
        viewBox="0 0 1024 1024"
        width={size}
        height={size}
      >
        <path
          d={getPath(iconName)}
          data-testid={`sb-icon-${iconName}`}
        />
      </svg>
    </span>
  );
};

Icon.propTypes = {
  /**
 * Name of icon
 */
  iconName: PropTypes.string.isRequired,
  /**
* Size of icon
*/
  size: PropTypes.number,
  /**
* Classes of icon
*/
  className: PropTypes.string,
  /**
* onClick
*/
  onClick: PropTypes.func,
  /**
* style
*/
  style: PropTypes.object,
};

Icon.defaultProps = {
  iconName: "user",
  size: 50,
  onClick: () => { },
};

export default Icon;